import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MapPin, CheckCircle2 } from "lucide-react";

// Realistic mock data for social proof
const BOOKINGS = [
  { location: "Zurich, CH", room: "Junior Suite", time: "12 minutes ago" },
  { location: "London, UK", room: "Classic Double Room", time: "2 hours ago" },
  { location: "Bern, CH", room: "Family Suite", time: "45 minutes ago" },
  { location: "Munich, DE", room: "Superior Double", time: "25 minutes ago" },
  { location: "Geneva, CH", room: "Alpine Classic", time: "3 hours ago" },
  { location: "Paris, FR", room: "Junior Suite", time: "1 hour ago" },
];

export const SocialProofToast = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBooking, setCurrentBooking] = useState(BOOKINGS[0]);

  useEffect(() => {
    // Desktop only check
    if (window.innerWidth < 1024) return;

    // Initial delay: 5 seconds (Reduced for testing)
    const initialTimer = setTimeout(() => {
      triggerNotification();
    }, 5000);

    // Subsequent loop: Every 45-60 seconds
    const interval = setInterval(() => {
      triggerNotification();
    }, 55000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  const triggerNotification = () => {
    // Pick a random booking
    const randomBooking = BOOKINGS[Math.floor(Math.random() * BOOKINGS.length)];
    setCurrentBooking(randomBooking);
    setIsVisible(true);

    // Hide after 6 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 6000);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, x: -20 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: 20, x: 0 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="fixed bottom-32 left-6 z-[100] bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-white/20 p-3 max-w-xs hidden lg:flex items-center gap-3"
        >
          <div className="bg-green-50/80 p-1.5 rounded-full flex-shrink-0">
            <CheckCircle2 className="w-4 h-4 text-green-600" />
          </div>
          <div>
            <p className="text-xs font-medium text-gray-900 leading-tight">
              Someone from <span className="font-bold">{currentBooking.location}</span> just booked a <span className="text-neutral-900 font-medium">{currentBooking.room}</span>
            </p>
            <div className="flex items-center gap-1 mt-0.5">
              <MapPin className="w-2.5 h-2.5 text-gray-400" />
              <span className="text-[10px] text-gray-500">{currentBooking.time}</span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
